import * as Yup from 'yup'

const PermissionSchema = Yup.object().shape({
  id: Yup.number().required(),
  name: Yup.string().required(),
  i18n: Yup.string(),
  isChecked: Yup.boolean(),
})

const CategorySchema = Yup.object().shape({
  id: Yup.number().required(),
  name: Yup.string().required(),
  i18n: Yup.string(),
  permissions: Yup.array().of(PermissionSchema),
})

export const GroupsSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required('Insira um nome'),

    level: Yup.number()
      .typeError('O nível deve ser numérico')
      .min(0, 'O nível mínimo é 0')
      .max(998, 'O nível máximo é 998')
      .required('Informe o nível'),

    items: Yup.array()
      .of(CategorySchema)
      .test('has-checked-permission', 'Selecione ao menos uma permissão', (categories) => {
        if (!categories) return false

        return categories.some((category) =>
          category.permissions?.some((p: any) => p.isChecked === true)
        )
      }),
  })
}
